import { listingRealisationsMock, titresFiltresModelesFlexibleMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titresFiltresModelesFlexibleMock({ showOrderingFilter: false }),
  listingRealisationsMock({ context: 'mur', fallbackSuggestions: 'Aucun résultat trouvé.' }),
];

export const realisationsClientMurMock: SlugPage = {
  ...pageBase({
    title: 'Realisations Client - Mur',
    type: 'realisations',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
